(function () {
  if (window.CTTracking) return;

  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid'];
  var ATTRIBUTION_STORAGE_KEY = 'ct_attribution';
  var SESSION_STARTED_STORAGE_KEY = 'SessionStarted';

  function isReady() {
    return typeof window.clevertap !== 'undefined' && typeof window.clevertap.event !== 'undefined';
  }

  function captureAttribution() {
    var params = new URLSearchParams(window.location.search);
    var hasUtm = UTM_KEYS.some(function (key) {
      return params.has(key);
    });

    if (hasUtm) {
      var attribution = {};
      UTM_KEYS.forEach(function (key) {
        if (params.has(key)) attribution[key] = params.get(key);
      });
      try {
        sessionStorage.setItem(ATTRIBUTION_STORAGE_KEY, JSON.stringify(attribution));
      } catch (e) {}
      return attribution;
    }

    try {
      return JSON.parse(sessionStorage.getItem(ATTRIBUTION_STORAGE_KEY) || '{}');
    } catch (e) {
      return {};
    }
  }

  function pushEvent(name, properties) {
    var payload = Object.assign(
      {
        url: window.location.href,
        referrer: document.referrer || '',
      },
      captureAttribution(),
      properties || {}
    );

    console.log('[CleverTap]', name, payload);

    if (!isReady()) return;

    window.clevertap.event.push(name, payload);
  }

  function trackPageViewed() {
    var pageData = window.CT_PAGE_DATA || { type: 'other' };
    pushEvent('page_viewed', pageData);

    if (pageData.type === 'search') {
      pushEvent('search_performed', {
        search_term: pageData.search_term,
        results_count: pageData.results_count,
      });
    }

    if (pageData.type === 'cart') {
      pushEvent('cart_viewed', {
        item_count: pageData.item_count,
        total_price: pageData.total_price,
        currency: pageData.currency,
      });
    }
  }

  function detectOperatingSystem() {
    var ua = navigator.userAgent;
    if (/Windows/i.test(ua)) return 'Windows';
    if (/Mac OS X/i.test(ua)) return 'Mac OS X';
    if (/Android/i.test(ua)) return 'Android';
    if (/iPhone|iPad|iPod/i.test(ua)) return 'iOS';
    if (/Linux/i.test(ua)) return 'Linux';
    return 'NA';
  }

  function detectBrowser() {
    var ua = navigator.userAgent;
    if (/Edg\//i.test(ua)) return 'Edge';
    if (/OPR\//i.test(ua) || /Opera/i.test(ua)) return 'Opera';
    if (/CriOS/i.test(ua)) return 'Chrome';
    if (/FxiOS/i.test(ua)) return 'Firefox';
    if (/Chrome\//i.test(ua)) return 'Chrome';
    if (/Firefox\//i.test(ua)) return 'Firefox';
    if (/Safari\//i.test(ua) && /Version\//i.test(ua)) return 'Safari';
    if (/Trident|MSIE/i.test(ua)) return 'Internet Explorer';
    return 'NA';
  }

  function detectDevice() {
    var ua = navigator.userAgent;
    if (/iPad|Tablet/i.test(ua)) return 'Tablet';
    if (/Mobi|Android|iPhone/i.test(ua)) return 'Mobile';
    return 'Desktop';
  }

  function croppedUrl() {
    return window.location.origin + window.location.pathname;
  }

  function pad(number) {
    return number < 10 ? '0' + number : '' + number;
  }

  function formattedDate(now) {
    return now.getFullYear() + '-' + pad(now.getMonth() + 1) + '-' + pad(now.getDate());
  }

  function formattedTime(now) {
    return pad(now.getHours()) + ':' + pad(now.getMinutes()) + ':' + pad(now.getSeconds());
  }

  // Mirrors the legacy GTM "Session Started" tag: fire once per session, guarding against
  // sessionStorage writes that silently fail (e.g. Safari private browsing).
  function trackSessionStarted() {
    if (sessionStorage.getItem(SESSION_STARTED_STORAGE_KEY)) return;

    try {
      sessionStorage.setItem(SESSION_STARTED_STORAGE_KEY, 'true');
    } catch (e) {}

    if (!sessionStorage.getItem(SESSION_STARTED_STORAGE_KEY)) return;

    var attribution = captureAttribution();
    var pageData = window.CT_PAGE_DATA || {};
    var now = new Date();

    var properties = {
      source: attribution.utm_source,
      medium: attribution.utm_medium,
      campaign: attribution.utm_campaign,
      operating_system: detectOperatingSystem(),
      browser: detectBrowser(),
      device: detectDevice(),
      city: pageData.customer_city,
      state: pageData.customer_state,
      country: pageData.customer_country,
      landing_page_url: window.location.href,
      cropped_url: croppedUrl(),
      date: formattedDate(now),
      time: formattedTime(now),
    };

    if (Object.prototype.hasOwnProperty.call(pageData, 'phone_number_exists')) {
      properties.phone_number_exists = pageData.phone_number_exists;
    }

    pushEvent('session_started', properties);
  }

  // Cart line items report price in cents; CleverTap events use the major currency unit.
  function cartItemProps(item) {
    return {
      product_id: item.product_id,
      variant_id: item.variant_id,
      product_title: item.product_title || item.title,
      variant_title: item.variant_title,
      price: item.price / 100,
      quantity: item.quantity,
      sku: item.sku,
      image: item.image,
    };
  }

  function indexItemsByKey(items) {
    var map = {};
    (items || []).forEach(function (item) {
      map[item.key] = item;
    });
    return map;
  }

  var cartCache = null;

  function refreshCartCache() {
    return fetch('/cart.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        cartCache = cart;
        return cart;
      })
      .catch(function () {});
  }

  function trackCartTotals(cart, eventName) {
    pushEvent(eventName, {
      item_count: cart.item_count,
      total_price: cart.total_price / 100,
      currency: cart.currency,
    });
  }

  function diffAndTrackCart(newCart) {
    if (!cartCache) {
      cartCache = newCart;
      trackCartTotals(newCart, 'cart_updated');
      return;
    }

    var oldMap = indexItemsByKey(cartCache.items);
    var newMap = indexItemsByKey(newCart.items);

    Object.keys(oldMap).forEach(function (key) {
      if (!newMap[key]) {
        pushEvent('removed_from_cart', cartItemProps(oldMap[key]));
      } else if (newMap[key].quantity !== oldMap[key].quantity) {
        pushEvent(
          'quantity_updated',
          Object.assign(cartItemProps(newMap[key]), { previous_quantity: oldMap[key].quantity })
        );
      }
    });

    Object.keys(newMap).forEach(function (key) {
      if (!oldMap[key]) {
        pushEvent('add_to_cart', cartItemProps(newMap[key]));
      }
    });

    cartCache = newCart;
    trackCartTotals(newCart, 'cart_updated');
  }

  function normalizeAddedItems(cartData) {
    if (!cartData) return [];
    if (Array.isArray(cartData.items)) return cartData.items;
    if (cartData.id) return [cartData];
    return [];
  }

  function handleCartUpdate(event) {
    if (!event) return;

    if (event.source === 'product-form') {
      normalizeAddedItems(event.cartData).forEach(function (item) {
        pushEvent('add_to_cart', cartItemProps(item));
      });
      refreshCartCache().then(function (cart) {
        if (cart) trackCartTotals(cart, 'cart_updated');
      });
      return;
    }

    if (event.source === 'cart-items' || event.source === 'quick-add') {
      diffAndTrackCart(event.cartData);
    }
  }

  function trackCartViewed() {
    if (cartCache) {
      trackCartTotals(cartCache, 'cart_viewed');
      return;
    }
    refreshCartCache().then(function (cart) {
      if (cart) trackCartTotals(cart, 'cart_viewed');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    trackSessionStarted();
    trackPageViewed();
    refreshCartCache();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, handleCartUpdate);
    }
  });

  window.CTTracking = {
    pushEvent: pushEvent,
    trackCartViewed: trackCartViewed,
  };
})();
